module.exports = __webpack_public_path__ + "img/frame-login.1702bc22.webp";